module.exports = __webpack_public_path__ + "img/icn_confirmar.894487b8.svg";